import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import { Loader } from 'components/UtilElements';
import { Dispatch } from 'redux';
import { UPDATE_CHILD_COURSES } from 'redux/actions';
import { API, request } from 'redux/api';
import { RootState } from 'redux/reducers';
import { ROUTES } from 'routes';

interface GetChildCoursesResponse extends MessageResponse {
  hasChildren: NonNullable<SessionData['courseDetails']['hasChildren']>;
  childCourses: SessionData['courseDetails']['childCourses'];
}

const getChildCourses = (courseId: string) => {
  return request<GetChildCoursesResponse>({
    url: API.COURSE_GET_CHILDREN(courseId),
    method: 'GET',
  });
};

interface CourseNavigatorProps {
  accessData: SessionData | null;
  setChildCourses(payload: GetChildCoursesResponse): Promise<void>;
}

const CourseNavigator = ({ accessData, setChildCourses }: CourseNavigatorProps) => {
  const [hasFetchedChildren, setHasFetchedChildren] = useState(false);

  useEffect(() => {
    if (accessData?.context !== 'course') return;

    getChildCourses(accessData.courseDetails.courseId)
      .then((response) => {
        setChildCourses(response);
      })
      .finally(() => {
        setHasFetchedChildren(true);
      });
  }, [accessData?.context, accessData?.courseDetails.courseId, setChildCourses]);

  if (!hasFetchedChildren) return <Loader />;

  if (!accessData) {
    return (
      <Redirect
        to={{
          pathname: ROUTES.MESSAGE_PAGE,
          state: { code: '403', message: 'You are not authorised to access this app.' },
        }}
      />
    );
  }

  if (accessData.courseDetails.hasChildren) {
    return <Redirect to={ROUTES.COURSES_SELECT_CHILD} />;
  }

  if (accessData.courseDetails.isImported) {
    return <Redirect to={ROUTES.COURSES} />;
  }

  return <Redirect to={ROUTES.COURSES_CREATE} />;
};

const mapStateToProps = ({ getAccess }: RootState) => {
  return { accessData: getAccess };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setChildCourses: async (payload: GetChildCoursesResponse) => {
      dispatch({ type: UPDATE_CHILD_COURSES, payload });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CourseNavigator);
